/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

export function defaultMapper(apiObject) {
  return apiObject || {};
}
